const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://programwithjr.com',
  title: 'Home',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'José Ramón (JR)',
  role: 'Full Stack Programmer and Mentor',
  description1:
    'Spanish Engineer with over ten years of experience in the Computer Programming Industry.', 
  description2:
     'Linux user before 2010, I have used different languages, mainly C, Java, Kotlin and Typescript for the frontend.',
  description3: 'I like automating tasks with scripts and exploring different technologies and frameworks, especially pure functional programming languages.',
  description4: 'I also have experience in mentoring and coaching students and junior developers.',
  resume: 'https://github.com/josealonso',
  social: {
    linkedin: 'https://www.linkedin.com/in/joseramonalonsotapia/',
    github: 'https://github.com/josealonso',
    exercism: 'https://exercism.org/profiles/josealonso',
    youtube: 'https://www.youtube.com/@ProgramWithJR'
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Project 1',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 2',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 3',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Linux',
  'C',
  'C++',
  'Java',
  'Kotlin',
  'Spring Boot',  
  'JavaScript',
  'TypeScript',
  'React',
  'Material UI',
  'Git',
  'CI/CD',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'program.with.jr@gmail.com',
}

const blog = [
  {
    title: 'Blog1',
    description:
      'My hashnode blog',
    link: 'https://blog.programwithjr.com',
  }
]
export { header, about, projects, skills, contact, blog }
